import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GMOU_FEATURE_KEY,
  GmouState,
  GmouPartialState,
  gmouAdapter,
} from './gmou.reducer';
import { GMOUDto } from '@cradua/data';

// Lookup the 'Gmou' feature state managed by NgRx
export const getGmouState = createFeatureSelector<GmouPartialState, GmouState>(
  GMOU_FEATURE_KEY
);

const { selectAll, selectEntities } = gmouAdapter.getSelectors();

export const getGmouLoaded = createSelector(
  getGmouState,
  (state: GmouState) => state.loaded
);

export const getGmouError = createSelector(
  getGmouState,
  (state: GmouState) => state.error
);

export const loadingGmou = createSelector(
  getGmouState,
  (state: GmouState) => state.loaded
);

export const getAllGmou = createSelector(getGmouState, (state: GmouState) =>
  selectAll(state)
);

export const getGmouEntities = createSelector(
  getGmouState,
  (state: GmouState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getGmouState,
  (state: GmouState) => state.selectedGmouId
);

export const getSelected = createSelector(
  getGmouEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllGmou,
  getSelectedId,
  (users: GMOUDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.GMOUTitle.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.GMOUDescription.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
